import { render, staticRenderFns } from "./u-pagination-text-tile.vue?vue&type=template&id=7184ded2&scoped=true&"
import script from "./u-pagination-text-tile.vue?vue&type=script&lang=js&"
export * from "./u-pagination-text-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184ded2",
  null
  
)

export default component.exports